export function handleRangeSelect() {
    if($('.js-range-select').length <= 0){
        return;
    }

    $('.js-range-select').each(function(index, el){
        let $rangeSelect = $(el);

        let $rangeSelectOption = $rangeSelect.find('.js-range-select-option');

        let quantities = {
            adults:   1,
            children: 0
        }

        $rangeSelectOption.on('click', '.js-count', function () {
            let $parent = $(this).closest('.js-range-select-option');

            let min = parseInt($parent.attr('data-min'));
            let max = parseInt($parent.attr('data-max'));

            let type = $parent.attr('data-type');
            let quantity = quantities[type];

            if ($(this).attr('data-type') === 'increase') {
                quantity++;
            } else {
                quantity--;
            }

            $parent.find('.js-count.range-select__btn--plus').prop('disabled', quantity >= max);
            $parent.find('.js-count.range-select__btn--minus').prop('disabled', quantity <= min);
            $rangeSelect.find('.js-quantity-display[data-type="'+ type +'"]').text(quantity);

            quantities[type] = quantity;

            let $selectBox = $rangeSelect.find('.js-quantity-input[data-type="'+ type +'"]');
            let $option = $selectBox.find('[data-quantity="'+ quantity +'"]');

            if($option.length === 1){
                $option.prop('selected', true);
            } else {
                $selectBox.find('[value=""]').prop('selected', true);
            }

            return false;
        });
    });

    $('body').on('click', '.js-toggle-range-dropdown', function () {
        $(this).closest('.js-range-dropdown').toggleClass('range-dropdown--active');
    }).on("click", (e) => {
        if ($(e.target).closest(".js-range-dropdown").length === 0) {
            $(".js-range-dropdown").removeClass('range-dropdown--active');
        }
    });

}
